<template>
  <div class="device_warnings_count">
    <header>
      <h2>{{ $t("deviceWarningsCount.title") }}</h2>
      <a-space>
        <a-button @click="goBack">{{ $t("buttons.goBack") }}</a-button>
        <a-button type="primary" @click="renderDeviceWarningsTable(1)">{{ $t("buttons.search") }}</a-button>
        <a-button type="primary" @click="exportDevcieWarnings" :loading="isExporting">{{ $t("buttons.export") }}</a-button>
      </a-space>
    </header>
    <el-table
      v-loading="isTableLoading"
      :data="warnings"
    >
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("device.code") }}
            <span
              class="icons unset"
              @click="sortTable($event, 'deviceCode')"
            >
              <a-icon type="caret-up"></a-icon>
              <a-icon type="caret-down"></a-icon>
            </span>
            <a-input v-model="queryParams.deviceCode" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo.deviceCode">
            {{ scope.row.deviceCode }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("common.deviceName") }}
            <span
              class="icons unset"
              @click="sortTable($event, 'deviceName')"
            >
              <a-icon type="caret-up"></a-icon>
              <a-icon type="caret-down"></a-icon>
            </span>
            <a-input v-model="queryParams.deviceName" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo.deviceName">
            {{ scope.row.deviceName }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("common.deviceType") }}
            <a-select v-model="filterParams.deviceType" @change="renderDeviceWarningsTable(1)">
              <a-select-option value="">
                {{ $t("common.all") }}
              </a-select-option>
              <a-select-option
                v-for="(v, k) in deviceTypeMap"
                :key="k"
              >
                {{ v }}
              </a-select-option>
            </a-select>
          </div>
        </template>
        <template slot-scope="scope">
          {{ deviceTypeMap[scope.row.deviceType] }}
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("common.model") }}
            <a-input v-model="queryParams.model" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo.model">
            {{ scope.row.model }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column width="160">
        <template #header>
          <div class="tableHeader">
            {{ $t("common.power") }}
            <span
              class="icons unset"
              @click="sortTable($event, 'power')"
            >
              <a-icon type="caret-up"></a-icon>
              <a-icon type="caret-down"></a-icon>
            </span>
            <div style="width: 100%;">
              <a-select style="width: 50%" v-model="multipleParams.power.condition" @change="renderDeviceWarningsTable(1)">
                <a-select-option value="">{{ $t("common.all") }}</a-select-option>
                <a-select-option
                  v-for="(v, k) in conditions"
                  :key="k"
                >
                  {{ v }}
                </a-select-option>
              </a-select>
              <a-input-number style="width: 50%; margin-top: -.3px;" v-model="multipleParams.power.value" @keyup.enter="renderDeviceWarningsTable(1)" />
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          {{ scope.row.power }}
        </template>
      </el-table-column>
      <el-table-column width="210">
        <template #header>
          <div class="tableHeader">
            {{ $t("common.customer") }}
            <a-input v-model="queryParams.company" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo.company">
            {{ scope.row.company }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("warning.saleOrg") }}
            <a-input v-model="queryParams['salemen.organizationName']" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo['salemen.organizationName']">
            {{ scope.row.salesOrgnizations }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("common.salesMen") }}
            <a-input v-model="queryParams['salemen.realName']" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo['salemen.realName']">
            {{ scope.row.salesNames }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("warning.serviceOrg") }}
            <a-input v-model="queryParams['serviceMan.organizationName']" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo['serviceMan.organizationName']">
            {{ scope.row.serviceOrgnizations }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("warning.serviceName") }}
            <a-input v-model="queryParams['serviceMan.realName']" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo['serviceMan.realName']">
            {{ scope.row.serviceNames }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="tableHeader">
            {{ $t("overview.list") }}
            <a-input v-model="queryParams.warnings" @keyup.enter="renderDeviceWarningsTable(1)" />
          </div>
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highlightInfo.warnings">
            {{ scope.row.warnings }}
          </text-highlight>
        </template>
      </el-table-column>
    </el-table>
    <a-pagination
      style="float: right; margin-top: 20px;"
      :current="pagination.current"
      :pageSize="pagination.pageSize"
      :total="pagination.total"
      @change="renderDeviceWarningsTable"
    />
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import {
  postDeviceAllWarnings,
  postExportDeviceAllWarnings
} from "@/api/warning"
import { getDict } from "@/api/dict"

import TextHighlight from "vue-text-highlight"

export default {
  components: {
    TextHighlight
  },
  props: {
    toggleComponent: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isTableLoading: false,
      isExporting: false,
      warnings: [],
      conditions: {
        eq: "=",
        ne: "≠",
        gt: ">",
        ge: "≥",
        lt: "<",
        le: "≤"
      },
      queryParams: {
        deviceCode: "",
        deviceName: "",
        model: "",
        company: "",
        "salemen.organizationName": "",
        "salemen.realName": "",
        "serviceMan.organizationName": "",
        "serviceMan.realName": "",
        warnings: ""
      },
      filterParams: {
        deviceType: ""
      },
      sortParams: {},
      multipleParams: {
        power: {
          condition: "",
          value: undefined
        }
      },
      highlightInfo: {
        deviceCode: "",
        deviceName: "",
        model: "",
        company: "",
        "salemen.organizationName": "",
        "salemen.realName": "",
        "serviceMan.organizationName": "",
        "serviceMan.realName": "",
        warnings: ""
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      deviceTypeMap: {}
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.translate()
    }
  },
  mounted() {
    this.render()
  },
  methods: {
    /* 初始渲染 */
    render() {
      this.setDeviceTypeMap()
      this.renderDeviceWarningsTable()
    },
    async setDeviceTypeMap() {
      const types = await this.requestDeviceTypes()
      
      let t
      const map = {}
      for (let i = 0; i < types.length; i++) {
        t = types[i]

        map[t.value] = t.text
      }

      this.deviceTypeMap = map
    },
    /* 复用方法 */
    translate() {
      this.setDeviceTypeMap()
    },
    setSearchParams() {
      const params = {
        query: [],
        filter: [],
        sort: []
      }

      let value
      for (let key in this.queryParams) {
        value = this.queryParams[key] = this.queryParams[key].trim()

        if (value) {
          params.query.push({
            field: key,
            value
          })
        }
      }

      for (let key in this.filterParams) {
        value = this.filterParams[key]

        if (value) {
          params.filter.push({
            field: key,
            value
          })
        }
      }

      for (let key in this.sortParams) {
        value = this.sortParams[key]

        if (value !== "unset") {
          params.sort.push({
            field: key,
            value
          })
        }
      }

      let o
      for (let outerKey in this.multipleParams) {
        o = this.multipleParams[outerKey]

        if (o.condition && (o.value || o.value === 0)) {
          params.filter.push({
            field: outerKey,
            req: o.condition,
            value: o.value
          })
        }
      }

      if (params.filter.length) {
        params.filter.push({
          field: "mode",
          value: "AND"
        })
      }

      return params
    },
    async renderDeviceWarningsTable(p = this.pagination.current) {
      this.pagination.current = p
      this.isTableLoading = true
      const { records, total } = await this.requestDeviceAllWarnings()
      
      this.warnings = records.map(r => {
        let salesmenMap = {}, serviceMansMap = {}

        if (r.salesmen?.length) {
          r.salesmen.forEach(s => {
            salesmenMap[s.username] = s
          })
        }

        if (r.serviceMan?.length) {
          r.serviceMan.forEach(s => {
            serviceMansMap[s.username] = s
          })
        }

        let salesOrgnizations = "", salesNames = ""
        for (let key in salesmenMap) {
          salesOrgnizations += salesmenMap[key].organizationName + ", "
          salesNames += salesmenMap[key].realName + ", "
        }
        r.salesOrgnizations = salesOrgnizations.slice(0, -2)
        r.salesNames = salesNames.slice(0, -2)
        
        let serviceOrgnizations = "", serviceNames = ""
        for (let key in serviceMansMap) {
          serviceOrgnizations += serviceMansMap[key].organizationName + ", "
          serviceNames += serviceMansMap[key].realName + ", "
        }
        r.serviceOrgnizations = serviceOrgnizations.slice(0, -2)
        r.serviceNames = serviceNames.slice(0, -2)

        return r
      })

      for (let key in this.highlightInfo) {
        this.highlightInfo[key] = this.queryParams[key]
      }

      this.pagination.total = total
      this.isTableLoading = false
    },
    /* 事件 */
    sortTable(e, field) {
      let node = e.target
      while (node.nodeName !== "SPAN") {
        node = node.parentNode
      }

      let originClass = node.classList[1], c
      node.classList.remove(originClass)

      switch(originClass) {
        case "unset":
          c = "ASC"
          break
        case "ASC":
          c = "DESC"
          break
        case "DESC":
          c = "unset"
          break
        default:
          break
      }

      node.classList.add(c)
      this.sortParams[field] = c
      this.renderDeviceWarningsTable()
    },
    goBack() {
      this.toggleComponent("WarningType", {}, [])
    },
    async exportDevcieWarnings() {
      this.isExporting = true
      const { success, data, message } = await this.requestExportDevcieWarnings()
      if (success) {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement("a")
        link.style.display = "none"
        link.href = url
        link.download = "设备预警统计.xlsx"
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
        this.$message.success(this.$t("messages.success"))
      }
      this.isExporting = false
    },
    /* 请求 */
    async requestDeviceAllWarnings() {
      try {
        const { data } = await postDeviceAllWarnings(
          this.pagination.current,
          this.pagination.pageSize,
          this.setSearchParams() 
        )
        return data
      } catch(e) {
        console.log(e)
        return {
          records: [],
          total: 0
        }
      }
    },
    async requestDeviceTypes() {
      const lang = this.lang === "en" ? "en-US" : "zh-CN"

      try {
        const { data } = await getDict(lang, "deviceType")
        return data.content
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async requestExportDevcieWarnings() {
      try {
        const { data, message } = await postExportDeviceAllWarnings(this.setSearchParams())
        return {
          success: true,
          data,
          message
        }
      } catch(e) {
        console.log(e)
        return {
          success: false
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.device_warnings_count {
  width: 100%;
  height: 100%;
  padding: 20px;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tableHeader {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    text-align: left;
  
    .ant-select {
      width: 100%;
    }

    
    span.icons {
      position: absolute;
      right: 18px;
      cursor: pointer;
    }

    .anticon-caret-up {
      position: absolute;
      top: -1px;
      right: -8px;
      font-size: 14px;
      color: #ccc;
    }

    span.ASC .anticon-caret-up {
      color: #1890ff;
    }

    span.DESC .anticon-caret-down {
      color: #1890ff;
    }

    .anticon-caret-down {
      position: absolute;
      top: 8px;
      right: -8px;
      font-size: 14px;
      color: #ccc;
    }
  }
}
</style>